import React, { useCallback, useContext, useEffect, useState } from 'react';
import { TbColumnInsertLeft, TbColumnRemove } from 'react-icons/tb';
import { Slider } from 'office-ui-fabric-react';
import { getAreaCssBackgroundColor, getActionEffort, getCapabilityEffort, getCapabilityMaxEffort } from '../../../core/sales-items';
import { timelineConfig as config, getTimelineActionCssBackgroundColor, getTimelineActionCssTop, getTimelineItemCssHeight, getTimelineItems, getTimelineMonths, getTimelineActionWidth, getTimelineWidth, getTimelineHeight, getTimelineActionCssLeftPosition } from '../../../core/sales-timeline';
import { WsSalesSolutionAction, WsSalesSolutionItem } from '../../../core';
import { getTimelineRolesFromCapabilities } from '../../../helpers/timeline-helpers';
import { WsPanelContext } from '../SalesContainerWithPanel';
import './SalesTimeline2.scss';
import { isAnyActionSelected } from "../../../helpers/item-helpers";







const WsSalesTimelineWeek = (props: { months: string[], weekNumberVisible: boolean }) => {
  const elementList: JSX.Element[] = [];

  let w = 1;

  props.months.forEach((month: string, index: number) => {

    let i = 1;

    while (i < 5) {

      elementList.push(
        <td key={`ws-sales-timeline-week-${w}`} className="ws-sales-timeline-week">{ props.weekNumberVisible ? `W${w}` : '' }</td>
      );

      w++;
      i++;
    }
  });

  return (
    <>{elementList}</>
  );
};



const cssStartLeftPosition = 30 + 1;

const getActionElementList = (items: WsSalesSolutionItem[], item: WsSalesSolutionItem, itemActions: WsSalesSolutionAction[], actionStartDate: Date, animate: number, onClickShowAction: (item: WsSalesSolutionItem | WsSalesSolutionAction | undefined) => Promise<void>) => {
  const elementList: JSX.Element[] = [];

  let actionIndex: number = 0;

  itemActions.forEach((action: WsSalesSolutionAction) => {

    if (isAnyActionSelected(action)) {

      // effort

      let effort = getActionEffort(action, { includeChildActions: true });

      let effortWidth = getTimelineActionWidth(action);



      // parallel

      const parallel = action.parallel > 0 ? action.parallel : 1;

      effort = effort / parallel;

      effortWidth = effortWidth / parallel;



      [ ...Array(parallel) ].forEach((value: any, index: number) => {



        // css

        const cssBackgroundColor = getTimelineActionCssBackgroundColor(`${item.areaId}`);

        const cssTop = getTimelineActionCssTop(actionIndex, config.waterfall);

        const cssLeft = getTimelineActionCssLeftPosition(items, itemActions, action.id);

        let cssWidth = effortWidth - config.action.arrowWidth;
        if (cssWidth < 0) {
          cssWidth = 0;
        }

        const cssZindex = 1000 - (actionIndex * 1);



        // element

        elementList.push(
          <div
            key={`ws-sales-timeline-item-${item.id}-action-${actionIndex}`}
            className="ws-sales-timeline-item-action"
            style={{
              backgroundColor: cssBackgroundColor,
              top: cssTop,
              left: cssLeft + cssStartLeftPosition,
              width: animate === 1 ? cssWidth : 0,
              zIndex: cssZindex
            }}
            onClick={() => {
              onClickShowAction(action);
            }}
          >
            <div className="ws-sales-timeline-item-action-name">{action.name} ({effort.toFixed(1)}h)</div>
            <div
              className="ws-sales-timeline-item-action-arrow"
              style={{
                borderLeftColor: cssBackgroundColor
              }}
            ></div>
          </div>
        );

        actionIndex = actionIndex + 1;
      });
    }
  });



  // return

  return elementList;
};


type WsSalesTimelineActionsProps = {
  items: WsSalesSolutionItem[];
  item: WsSalesSolutionItem;
  itemActions: WsSalesSolutionAction[];
  actionStartDate: Date;
  onClickShowAction: (item: WsSalesSolutionItem| WsSalesSolutionAction | undefined) => Promise<void>;
};

const WsSalesTimelineActions = (props: WsSalesTimelineActionsProps) => {

  const [ animate, setAnimate ] = useState<number>(0);

  useEffect(() => {

    setTimeout(() => {
      setAnimate(1);
    }, 250);

  }, []);

  return (
    <>
      {getActionElementList(props.items, props.item, props.itemActions, props.actionStartDate, animate, props.onClickShowAction)}
    </>
  );
};



type WsSalesTimelineItemsProps = {
  items: WsSalesSolutionItem[];
  itemStartDate: Date;
  months: string[];
  onClickShowAction: (item: WsSalesSolutionItem | WsSalesSolutionAction | undefined) => Promise<void>;
};

const WsSalesTimelineItems = (props: WsSalesTimelineItemsProps) => {
  const elementList: JSX.Element[] = [];

  const monthCount = props.months.length; // TODO: remove?
  const weekCount = monthCount * 4;

  props.items.forEach((item: WsSalesSolutionItem, index: number) => {

    if (item.selected && isAnyActionSelected(item)) {

      const cssBackgroundColor = getAreaCssBackgroundColor(item.areaId, 4);
      // const cssColor = '#ffffff'; // getAreaCssColor(item.areaId, 4);


      // capability

      elementList.push(
        <tr
          key={`ws-sales-timeline-item-name-${index}`}
          className="ws-sales-timeline-item"
        >
          <td
            className="ws-sales-timeline-item-name"
            style={{
              backgroundColor: cssBackgroundColor,
              // color: cssColor
            }}
            colSpan={weekCount + 1}
            onClick={() => {
              props.onClickShowAction(item);
            }}
          >
            <div
              className="ws-sales-timeline-item-name-div"
              style={{
                color: '#ffffff'
              }}
            >{item.name} ({getCapabilityEffort(item, 1, { includeChildCapabilities: false })}h)</div>
          </td>
        </tr>
      );


      // actions

      elementList.push(
        <tr
          key={`ws-sales-timeline-item-${index}`}
          className="ws-sales-timeline-item"
        >
          <td
            className="ws-sales-timeline-item-area"
            style={{
              backgroundColor: cssBackgroundColor,
              width: 30,
              height: getTimelineItemCssHeight(item)
            }}
          >
            {/* {item.name} */}
            {
              item.actions && Array.isArray(item.actions) && item.actions.length > 0
              &&
              <WsSalesTimelineActions
                items={props.items}
                item={item}
                itemActions={item.actions}
                actionStartDate={props.itemStartDate}
                onClickShowAction={props.onClickShowAction}
              />
            }
          </td>
          <WsSalesTimelineWeek months={props.months} weekNumberVisible={false} />
        </tr>
      );

    }

  });


  // return

  return (
    <>
      {elementList}
    </>
  );
};


type WsSalesTimelineProps = {
  startDate: Date;
  items: WsSalesSolutionItem[];
  screenshot: boolean;
  avanade: boolean;
};

const WsSalesTimeline = (props: WsSalesTimelineProps) => {

  const panelContext = useContext(WsPanelContext);



  const onClickShowAction = useCallback(async (item: WsSalesSolutionItem | WsSalesSolutionAction | undefined) => {

    if (props.avanade) {
      panelContext.setShowAction(item);
    }

  }, []);

  // console.log(props.startDate.toISOString());

  // console.log(props.items);

  const timelineItems = getTimelineItems(props.items, true); // transform itemTree to itemList

  // console.log(timelineItems);

  const maxEffort = getCapabilityMaxEffort(timelineItems);

  const timelineMonths = getTimelineMonths(maxEffort);

  const timelineWidth = getTimelineWidth(maxEffort);

  const timelineHeight = getTimelineHeight(timelineItems);

  const monthElements = timelineMonths.map((month: string, index: number) => {
    return (
      <td key={`ws-sales-timeline-month-${month}-${index}`} className="ws-sales-timeline-month" colSpan={4}>{month}</td>
    );
  });



  useEffect(() => {
    // console.clear();

    const timelineRoles = getTimelineRolesFromCapabilities(props.items, timelineItems, props.startDate);

    // console.log(timelineRoles);
    // console.log(props.items);

  }, [ props.items ]);



  return (
    <div className="ws-sales-timeline">

      {
        props.avanade
        &&
        !props.screenshot
        &&
        <div className="ws-sales-timeline-adjustments">
          {/* <button
            className="button is-light"
            onClick={() => {
              // alert('click');
            }}
          >
            <RiEqualizerLine />
          </button> */}

          <div className="ws-sales-timeline-adjustment ws-sales-timeline-scale">
            <Slider
              label={'Scale'}
              min={0.1}
              max={2}
              step={0.1}
              defaultValue={1}
              // value={complexity}
              showValue={true}
              valueFormat={(value: number) => {
                return value.toFixed(1);
              }}
              snapToStep
              onChanged={(event: MouseEvent | TouchEvent | KeyboardEvent, value: number) => {
                // setComplexity(value);
              }}
            />
          </div>

          <div className="ws-sales-timeline-adjustment ws-sales-timeline-column">
            <button
              className="button is-light"
              onClick={() => {
                // alert('Cheers!');
              }}
            >
              <TbColumnInsertLeft />
            </button>
          </div>

          <div className="ws-sales-timeline-adjustment ws-sales-timeline-column">
            <button
              className="button is-light"
              onClick={() => {
                // alert('Cheers!');
              }}
            >
              <TbColumnRemove />
            </button>
          </div>

        </div>
      }

      <div className="ws-sales-timeline-scroll ws-scroll">
        <table data-width={timelineWidth} data-height={timelineHeight}>
          <tbody>
            <tr>
              <td></td>
              {monthElements}
            </tr>
            <tr>
              <td></td>
              <WsSalesTimelineWeek months={timelineMonths} weekNumberVisible={true} />
            </tr>
            <WsSalesTimelineItems
              items={timelineItems}
              itemStartDate={props.startDate}
              months={timelineMonths}
              onClickShowAction={onClickShowAction}
            />
          </tbody>
        </table>
      </div>

    </div>
  );
};




export {
  WsSalesTimeline as WsSalesTimeline2
};
